import React, { useState, useEffect } from 'react';
import { mediaAPI } from '../services/api';

const MediaPicker = ({ show, onClose, onSelect }) => {
  const [media, setMedia] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (show) {
      fetchMedia();
      setSelected(null); // Reset selection when opened
    }
  }, [show]);

  const fetchMedia = async () => {
    setLoading(true);
    try {
      const response = await mediaAPI.getAll({ type: 'image', limit: 50 });
      console.log('Media API response:', response);
      
      if (response.data && response.data.success) {
        setMedia(response.data.data.media || []);
      } else {
        setMedia([]);
      }
    } catch (error) {
      console.error('Failed to fetch media:', error);
      setMedia([]);
    } finally {
      setLoading(false);
    }
  };

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('used_in', 'article');

      const response = await mediaAPI.upload(formData);
      console.log('Upload response:', response);
      
      if (response.data && response.data.success) {
        const newMedia = response.data.data;
        setMedia([newMedia, ...media]);
        setSelected(newMedia);
        alert('Image uploaded successfully!');
      }
    } catch (error) {
      console.error('Upload error:', error);
      alert('Upload failed. Please try again.');
    } finally {
      setUploading(false);
    }
  };

  const handleSelect = () => {
    if (selected) {
      console.log('Selected image URL:', selected.url);
      onSelect(selected.url);
      onClose();
    }
  };

  if (!show) return null;

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Media Library</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            <div className="mb-3">
              <label className="btn btn-primary btn-sm">
                <input 
                  type="file" 
                  accept="image/*" 
                  onChange={handleUpload} 
                  style={{ display: 'none' }} 
                  disabled={uploading}
                />
                {uploading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Uploading...
                  </>
                ) : (
                  '+ Upload Image'
                )}
              </label>
            </div>

            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : media.length === 0 ? (
              <div className="text-center py-5 text-muted">
                <i className="bi bi-image" style={{ fontSize: '3rem' }}></i>
                <p className="mt-3">No images yet. Upload your first image above.</p>
              </div>
            ) : (
              <div className="row g-3">
                {media.map((item) => (
                  <div key={item.id} className="col-md-3 col-sm-4 col-6">
                    <div
                      className={`border rounded p-2 ${selected?.id === item.id ? 'border-primary border-3' : 'border-secondary'}`}
                      onClick={() => setSelected(item)}
                      style={{ cursor: 'pointer', transition: 'all 0.2s' }}
                    >
                      <img 
                        src={item.url} 
                        alt={item.original_filename} 
                        className="w-100 rounded" 
                        style={{ height: '120px', objectFit: 'cover' }} 
                      />
                      <small className="d-block mt-2 text-truncate text-muted">
                        {item.original_filename}
                      </small>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button 
              type="button" 
              className="btn btn-primary" 
              onClick={handleSelect} 
              disabled={!selected}
            >
              Select Image
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaPicker;